export default "__VITE_ASSET__6bddfbe0__"